var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimelineBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1441,
    height: 3533,
    viewBox: "0 0 1441 3533",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M1940.5 138.455L705.638 336.699C705.638 336.699 -46.0675 467.56 -296.172 510.393C-546.277 553.225 -535.878 551.88 -496.566 557.842C-457.255 563.805 -389.346 577.116 -74.0452 705.485C241.256 833.854 801.89 1076.88 1122.95 1221.2C1444.01 1365.51 1508.51 1403.76 1546.28 1427C1584.04 1450.23 1593.11 1457.29 1593.35 1464.1C1593.58 1470.91 1584.7 1477.25 1276.56 1501.01C968.416 1524.77 361.28 1565.75 32.5203 1590.84C-296.239 1615.92 -328.223 1623.86 -339.321 1627.36C-341.182 1627.95 -300.532 1633.26 -16.187 1745.71C240.376 1847.18 723.816 2063.81 1068.55 2229.5C1413.29 2395.19 1604.4 2509.79 1702.55 2573.81C1800.71 2637.83 1800.13 2647.81 1796.31 2654.89C1779.21 2686.65 1734.23 2671.79 1558.38 2695.45C1392 2717.83 1071.68 2769.38 900.934 2797.72C730.183 2826.05 719.392 2831.68 777.903 2852.98C836.415 2874.27 964.558 2911.05 1128.79 2975.68C1293.02 3040.3 1489.45 3131.66 1618.52 3197.18C1747.59 3262.7 1803.34 3299.61 1836.51 3322.64C1869.69 3345.67 1878.6 3353.7 1887.78 3361.97",
    stroke: "url(#paint0_linear_302_53)",
    strokeWidth: 241.66,
    strokeLinecap: "square",
    strokeLinejoin: "bevel"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_302_53",
    x1: 682.851,
    y1: 1355.89,
    x2: 572.071,
    y2: 3145.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#115EF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#115EF3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineBg);
export default __webpack_public_path__ + "static/media/timeline-bg.a41a7f39b8d5d5ffc63c2cd9189a1372.svg";
export { ForwardRef as ReactComponent };